module.exports = __webpack_public_path__ + "img/upload-icon.0ad76311.svg";